












import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "PromoteViewItem",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    img: { type: String, required: true },
    imgBig: { type: String, required: true },
  },
});
